<div class="menu-buttons">
  <app-floorplan-menu-item-buttons>
    <button
      odxButton
      variant="primary"
      (click)="imageInput.click()"
      [odxTooltip]="tooltipTextUploadImage"
      [odxTooltipOptions]="{ position: 'bottom' }"
    >
      <odx-icon name="upload" variant="primary" size="medium"></odx-icon>
    </button>
    <button
      odxButton
      variant="primary"
      (click)="openCamera()"
      [odxTooltip]="tooltipTextTakeImage"
      [odxTooltipOptions]="{ position: 'bottom' }"
    >
      <odx-icon name="camera" variant="primary" size="medium"></odx-icon>
    </button>
    <app-toggle-visibility-button
      [visible]="floorplan.floorplanState.imagesVisible"
      (toggleEvent)="floorplan.floorplanState.imagesVisible = $event"
    >
    </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplan.floorplanState.imagesItemTextVisible"
      (toggleEvent)="updateImagesItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button
      [locked]="floorplan.floorplanState.imagesLocked"
      (toggleEvent)="floorplan.floorplanState.imagesLocked = $event"
    >
    </app-toggle-lock-button>

    <input
      type="file"
      (change)="onImageFileSelect($event)"
      accept="image/png, image/jpg, image/jpeg, image/gif, image/svg, image/svg+xml, imagage/webp, image/heic"
      class="hidden"
      [attr.multiple]="businessScope === BusinessScope.FGDS ? true : null"
      #imageInput
    />
  </app-floorplan-menu-item-buttons>
</div>

<hr />

<div class="imported-images">
  <h6 class="odx-title-6" i18n="@@floorplan.menu.importedImages.header">Importierte Fotos</h6>
  <div class="images-container">
    @if (!images.length) {
      <p class="odx-text--small" i18n="@@floorplan.menu.noImportedImagesYet">Sie haben noch kein Foto importiert.</p>
    }
    @for (image of images; track image) {
      <div
        class="image-container"
        (click)="addImage(image.imageMetadata)"
        draggable="true"
        (dragstart)="dragImage(image.imageMetadata)"
      >
        <!-- prettier-ignore-attribute style -->
        <div class="image" [ngStyle]="{ 'background-image': 'url(' + image.previewUrl + ')' }"></div>
        <p class="image-text" [odxTooltip]="image.imageMetadata.name">
          {{ image.imageMetadata.name }}
        </p>
      </div>
    }
  </div>
</div>
